import { BaseModal, ModalResultType, ModalOptions } from "../../modal/index";
import { Template, LazyTemplate } from "../../template/index";

export default class SyncModal extends BaseModal
{
    public template = Template.lazy('/core/modals/sync/index.html');

    private syncForm: HTMLFormElement;
    private showReset: boolean;
    private resetCheckbox: HTMLElement;
    public data: SyncModalData;

    constructor(data?: SyncModalData)
    {
        super(data);
    }

    public beforeRender(): PromiseLike<void>
    {
        this.data.title = this.pgettext('Title', 'Synchronization');
        this.data.message = this.pgettext('Sync', "Synchronize your local data with the server.");
        
        let warningMesasge = this.pgettext('Sync', 'WARNING: All unsynchronized data will be lost');
        this.data.fullResetMessage = this.pgettext('Sync', "Select full reset if you'd like to perform a hard reset for the client. {warning}", {warning: `<b>${warningMesasge}</b>`}, false);
        
        return super.beforeRender();
    }

    public afterRender(): PromiseLike<void>
    {
        let continueButton = this.element.querySelector('button.continue') as HTMLButtonElement;
        continueButton.addEventListener('click', e =>
        {

            if (this.data.fullSync)
            {
                indexedDB.deleteDatabase(this.app.db.name);
                this.closeCountdown();
            }
            else
            {
                this.data.message = this.pgettext('Sync', "Synchronizing, please wait...");
                this.app.synchronizer.update().then(() =>
                {
                    this.element.classList.remove('error');
                    this.element.classList.add('success');
                    this.data.message = this.pgettext('Message', 'Successfully synchronized client!');
                    this.closeCountdown();
                }, (error) =>
                {
                    this.resetCheckbox.classList.remove('hidden');
                    this.element.classList.remove('success');
                    this.element.classList.add('error');
                    let defaultMessage = this.pgettext('Error', 'Unable to synchronize with the server. Please try again later or contact support');
                    this.data.message = this.pgettext('Error', 'Synchronization failed: {error}', {error: error.message || defaultMessage});
                    this.helpers.setFormEnabled(this.syncForm, true);
                });
            }
        });

        return super.afterRender();
    }

    private closeCountdown(seconds = 4)
    {
        let counterCallback = () =>
        {
            seconds--;
            this.data.countdown = this.pgettext('Message', 'Continuing in {seconds}...', {seconds: `<b>${seconds}</b>`}, false);
        }

        let counter = setInterval(counterCallback, 1000);
        counterCallback();

        setTimeout(() => 
        {
            location.reload();
            clearInterval(counter);
        }, seconds * 1000);
    }

    public onCancelButtonClick(e: MouseEvent)
    {
        this.close(ModalResultType.CANCEL);
    }

    public formSubmitted(form: HTMLFormElement): PromiseLike<void>
    {
        this.helpers.setFormEnabled(form, false);

        return Promise.resolve();
    }
}

export interface SyncModalData extends ModalOptions
{
    countdown?: string;
    fullResetMessage?: string;
    fullSync?: boolean;
}
